import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-website-layout',
  templateUrl: './website-layout.component.html',
  styleUrls: ['./website-layout.component.scss']
})
export class WebsiteLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
